import { isDarkOrLight } from '@hotjar/webapp/lib/isDarkOrLight';

/**
 * Services for Color related functions.
 */
angular.module('hjApp').service('ColorHelper', [
    function () {
        this.isDarkOrLight = isDarkOrLight;
    }
]);
